import React from 'react';
import IconWithTextCard from 'components/kea/IconWithTextCard';
import PropTypes from 'prop-types';
import { ReactComponent as UniqueVisitorsIcon } from 'assets/images/dashboard/kea-uniq-visitors-1.svg';
import { ReactComponent as ViewedProductsIcon } from 'assets/images/dashboard/kea-viewed-products-1.svg';
import { ReactComponent as ViewedIcon } from 'assets/images/dashboard/kea-recs-viewed-1.svg';
import { ReactComponent as ClickedIcon } from 'assets/images/dashboard/kea-recs-clicked-1.svg';
import { commaSeparate } from 'util/appUtils';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import styles from './RecsDashboard.module.scss';

const Summary = ({ summary }) => {
  const localizeMessage = useLocalizedMessage();
  const dataMetrics = [
    {
      title: commaSeparate(summary.totalCarts),
      subTitle: localizeMessage('recs.dashboard.summary.visitors'),
      imageIcon: <UniqueVisitorsIcon className="dashboard-summary-icon" />,
    }, {
      title: commaSeparate(summary.totalViews),
      subTitle: localizeMessage('recs.dashboard.summary.productsViewed'),
      imageIcon: <ViewedProductsIcon className="dashboard-summary-icon" />,
    }, {
      title: commaSeparate(summary.totalRecsViewed),
      subTitle: localizeMessage('recs.dashboard.summary.recommendationsViewed'),
      imageIcon: <ViewedIcon className="dashboard-summary-icon" />,
    }, {
      title: commaSeparate(summary.totalRecsClicked),
      subTitle: localizeMessage('recs.dashboard.summary.recommendationsClicked'),
      imageIcon: <ClickedIcon className="dashboard-summary-icon" />,
    },
  ];

  return (
    <div className={styles.metricGrid} data-testid="recommendation-summary">
      {dataMetrics.map(metric => (
        <div key={metric.subTitle} className={styles.metricCard}>
          <IconWithTextCard data={metric} />
        </div>
      ))}
    </div>
  );
};

export default Summary;

Summary.propTypes = {
  summary: PropTypes.shape({
    totalCarts: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    totalViews: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    totalRecsViewed: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    totalRecsClicked: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
};
